<template>
   <div class="mainbody">
   
      <div class="thirdLine"  v-scroll-animate="'slide-itemgk'">
            <!-- <span class="line"></span> -->
            <div class="txt">
              <span>总部部门及相关机构</span>
            </div>
            <!-- <span class="line"></span> -->
          
      </div> 
      <div style="width: 100%;text-align: center;"  v-scroll-animate="'fly-in-right5'"> 
        <!-- <img src="../../assets/img3/gaikuang1/jiagouPc1.png" class="pcImg" style="width: 85vw;" /> -->
        <div class="pcImg flexContainer"> 
            <div class="flexItem0522 borderLine"> 
             
              <ul> 
                <li> 省纪委监委驻集团公司纪检监察组</li>
                <li> 集团办公室</li>
                <li> 党群工作部</li>
                <li> 规划发展部</li>
                <li> 人事部</li>
              </ul>
            </div>

            <div class="flexItem0522 borderLine"> 
              <ul> 
                <li> 财务金融部</li>
                <li> 运营管理部</li>
                <li> 科创建设部</li>
                <li> 安全生产部</li>
                <li> 党委巡察督查办公室</li>
              </ul>
            </div>
            <div class="flexItem0522 "> 
              <ul> 
                <li> 合规审计部</li>
                <li> 工会办公室</li>
                <li> 后勤服务中心</li>
                <li> 信息宣传中心</li>
              </ul>
            </div>
        </div>

        <!-- <img src="../../assets/img3/gaikuang1/jiagouMobile.png" class="mobileImg" style="width: 90vw;" /> -->
         <!-- <div class="contantJiaGou"> 
            <div class="jiagouCeng0">
              <div> 党委会</div>
              <div> 董事会</div>
            </div>

            <div class="jiagouCeng1">
              <div class="flexL">党委会</div>
              <div class="flexR">
                  <div> 党委巡察督查办公室</div>
                  <div> 党群工作部</div>
              </div>
            </div>

            <div class="jiagouCeng1">
              <div class="flexL">董事会</div>
              <div class="flexR">
                  <div class="jingli"> 
                    经理层
                  </div>  
                  <div class="jiagouCeng3" > 
                  <div> 省纪委监委驻集团公司纪检监察组</div>
                  <div> 办公室</div>
                  <div> 人事部</div>
                  <div> 规划发展部</div>
                  <div> 财务资金部</div>
                  <div> 金融部</div>
                  <div> 资产管理部</div>
                  <div> 运营管理部</div>
                  <div> 工程管理部</div>
                  <div> 安全生产部</div>
                  <div> 风控审计部</div>
                  <div> 法律合规部</div>
                  <div> 科技创新部(正在筹建)</div>              
                 </div>
                  
              </div>
            </div>

             
         </div> -->
      </div>
     
      <!-- <div class="all_news_content flexDiv2">
       
        <div class="org-chart">
          <ul>
            <li>
              <div class="node topNode">河南中豫国际港务集团有限公司</div>
             <hr style="background-color: #cccccc;width: 0.5px;height: 35px; position:absolute;left: 55.9%;" />
              <ul>
                <li>
                  <div class="node secondNode">党委会</div>
                  <hr style="background-color: #cccccc;width: 0.5px;height: 13px; position:absolute;left: 51%;" />
                  <ul>
                    <li> <div class="node1">党委巡察督查办公室</div></li>
                    <li> <div class="node1">党群工作部</div></li>
                  </ul>
                </li>
                <li>
                  <div class="node secondNode">董事会</div>
                  <hr style="background-color: #cccccc;width: 0.5px;height: 13px; position:absolute;left: 49.9%;" />

                  <ul>
                    <li>
                      <div class="node thirdNode">经理层</div>
                      <hr style="background-color: #cccccc;width: 0.5px;height: 13px; position:absolute;left: 49.9%;" />

                      <ul class="jlc">
                        <li>
                          <div class="node">省纪委监委驻集团公司纪检监察组</div>
                        </li>
                        <li>
                          <div class="node">办公室</div>
                        </li>
                        <li>
                          <div class="node">人事部</div>
                        </li>
                        <li>
                          <div class="node">规划发展部</div>
                        </li>
                        <li>
                          <div class="node">财务资金部</div>
                        </li>
                        <li>
                          <div class="node">金融部</div>
                        </li>
                        <li>
                          <div class="node">资产管理部</div>
                        </li>
                        <li>
                          <div class="node">运营管理部</div>
                        </li>
                        <li>
                          <div class="node">工程管理部</div>
                        </li>
                        <li>
                          <div class="node">安全生产部</div>
                        </li>
                        <li>
                          <div class="node">风控审计部</div>
                        </li>
                        <li>
                          <div class="node">法律合规部</div>
                        </li>
                        <li>
                          <div class="node">科技创新部（正在组建）</div>
                        </li>
                      </ul>
                    </li>

                  </ul>
                </li>

               
              </ul>
            </li>
          </ul>
        </div>


      </div> -->

</div>
</template>

<script>

export default {
  data() {
    return {
     
      activeIndex: 0,
      
      
    }
  },
  props: {
    
  },
  methods: {
    changeIndex(index) {
      this.activeIndex = index
      
      
    },
  },
}
</script>

<style lang="scss" scoped>
.flexContainer{
  width: 80%;
  margin:0 auto;
  padding:1rem 0;
  padding-bottom: 3rem;
  display: flex;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  .flexItem0522{
    flex: 1;
    ul{
      li{
        list-style: none;
        font-size: 1rem;
        line-height: 2.5rem;
        color: #333333;
      }
    }
  }
  .borderLine{
    border-right: 1px dashed #999999;
  }
}
 .mainbody{
  width: 100%;
   height: auto;
  background:url('../../assets/w/img3/gaikuang/gaikuang-zhanlue-bg.png');
  background-size:cover;
 }
	.org-chart {
		margin: 0 auto;
		/* background-color: #e87b1c	; */
	}

	.org-chart .node.topNode {
		background-color: #e4833e !important;
		color: #ffffff;
		font-size: 2rem;
	}

	.org-chart .node.secondNode {

		font-size: 1.5rem;
	}
  

	.org-chart .node.thirdNode {

font-size: 1.2rem;
}


	.org-chart ul {
		padding-top: 20px;
		position: relative;
		transition: all 0.5s;
	}

	.org-chart li {
		float: left;
		text-align: center;
		list-style-type: none;
		position: relative;
		padding: 20px 5px 0 5px;
		transition: all 0.5s;
	}

	.jlc li {
		width: 85px;
    @media screen and (max-width: 768px) {
      max-width: 4.4vw;
      }
	}

	.org-chart li::before,
	.org-chart li::after {
		content: '';
		position: absolute;
		top: 0;
		right: 50%;
		border-top: 1px solid #ccc;
		width: 50%;
		height: 20px;
	}

	.org-chart li::after {
		right: auto;
		left: 50%;
		border-left: 1px solid #ccc;
	}

	.org-chart li:only-child::after,
	.org-chart li:only-child::before {
		display: none;
	}

	.org-chart li:only-child {
		padding-top: 0;
	}

	.org-chart li:first-child::before,
	.org-chart li:last-child::after {
		border: 0 none;
	}

	.org-chart li:last-child::before {
		border-right: 1px solid #ccc;
		border-radius: 0 5px 0 0;
	}

	.org-chart li:first-child::after {
		border-radius: 5px 0 0 0;
	}

	.org-chart .node {
		padding: 10px 20px;
    font-size: 1rem;
		border: 1px solid #ccc;
		display: inline-block;
		border-radius: 5px;
		background: #fff;
		transition: all 0.5s;
    @media screen and (max-width: 768px) {
      padding: 5px 1px;
      font-size: 0.5rem;
    }
	}
  .node1{
    width: 65px;
    padding: 10px 20px;
    font-size: 1rem;
		border: 1px solid #ccc;
		display: inline-block;
		border-radius: 5px;
		background: #fff;
		transition: all 0.5s;
    @media screen and (max-width: 768px) {
      padding: 5px 1px;
      font-size: 0.5rem;
      max-width: 2rem;
      width: 1rem;
    }
  }

	.org-chart .node:hover {
		background: #e7f2ff;
		cursor: pointer;
	}


</style>